import styled from "styled-components";

// login page body
export const Containers = styled.div`
text-align:center;
`;

// title page body
export const TitlePage = styled.h1`
text-align:center;
`;

//Div button page body
export const DivBtn = styled.div`
position:relative;
top:25px;
`;

